(() => {
  'use strict';

  const FORCED_UNAVAILABLE_HANDLES = new Set(['jarabe-berro-y-cebolla-8-oz']);
  const lang = (document.documentElement.lang || 'es').toLowerCase();
  const isSpanish = lang.startsWith('es');
  let refreshTimer;

  const copyMap = new Map([
    ['Be the first to write a review', 'Sé el primero en escribir una reseña'],
    ['Write a review', 'Escribir una reseña'],
    ['No reviews yet', 'Aún no hay reseñas'],
    ['Ask a question', 'Hacer una pregunta']
  ]);

  const mainContent = () => document.getElementById('MainContent');

  const productHandleFromHref = (href) => {
    if (!href) return '';
    try {
      const url = new URL(href, window.location.origin);
      return url.pathname.match(/\/products\/([^/?#]+)/)?.[1] || '';
    } catch (_error) {
      return '';
    }
  };

  const normalizeSpanishLinks = () => {
    if (!isSpanish) return;

    document.querySelectorAll('a[href]').forEach((link) => {
      if (link.hasAttribute('hreflang') || link.getAttribute('lang') === 'en') return;
      const rawHref = link.getAttribute('href');
      if (!rawHref || rawHref.startsWith('#') || rawHref.startsWith('mailto:') || rawHref.startsWith('tel:')) {
        return;
      }

      try {
        const url = new URL(rawHref, window.location.origin);
        if (url.origin !== window.location.origin) return;
        if (url.pathname !== '/en' && !url.pathname.startsWith('/en/')) return;

        url.pathname = url.pathname.slice(3) || '/';
        link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
      } catch (_error) {
        // Leave malformed and non-HTTP links unchanged.
      }
    });
  };

  const translateReviewCopy = () => {
    if (!isSpanish) return;

    document.querySelectorAll('.jdgm-widget, [class*="jdgm-"]').forEach((root) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          const parent = node.parentElement;
          if (!parent || parent.closest('script, style, noscript, textarea')) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      });

      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((node) => {
        const original = node.nodeValue || '';
        const trimmed = original.trim();
        const replacement = copyMap.get(trimmed);
        if (replacement) node.nodeValue = original.replace(trimmed, replacement);
      });
    });
  };

  const removeLegacyProductSections = () => {
    const main = mainContent();
    if (!main?.dataset.template?.startsWith('product')) return;

    main
      .querySelectorAll('[id$="__section_qaHnVL"], [id$="__section_dFQJKC"]')
      .forEach((element) => element.remove());
  };

  const blockForcedUnavailableProduct = () => {
    const main = mainContent();
    if (!main?.dataset.template?.startsWith('product')) return;

    const handle = productHandleFromHref(window.location.href);
    if (!FORCED_UNAVAILABLE_HANDLES.has(handle)) return;

    main.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      form.querySelectorAll('input, select, button').forEach((control) => {
        control.disabled = true;
      });

      form.querySelectorAll('button[type="submit"], button[name="add"]').forEach((button) => {
        const label = button.querySelector('.button-text') || button;
        label.textContent = isSpanish ? 'Agotado temporalmente' : 'Temporarily sold out';
      });

      if (!form.querySelector('.mbl-forced-unavailable-notice')) {
        const notice = document.createElement('p');
        notice.className = 'mbl-forced-unavailable-notice';
        notice.setAttribute('role', 'status');
        notice.textContent = isSpanish
          ? 'Este producto está temporalmente agotado.'
          : 'This product is temporarily sold out.';
        form.prepend(notice);
      }
    });

    main.querySelectorAll('sticky-add-to-cart button, shopify-accelerated-checkout').forEach((control) => {
      control.setAttribute('hidden', '');
    });
  };

  const hideSoldOutCards = () => {
    const main = mainContent();
    if (!main || main.dataset.template?.startsWith('product')) return;

    main.querySelectorAll('product-card, .product-card, [data-product-card]').forEach((card) => {
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      const forcedUnavailable = FORCED_UNAVAILABLE_HANDLES.has(
        productHandleFromHref(link.getAttribute('href'))
      );
      const soldOut = forcedUnavailable || Array.from(card.querySelectorAll('*')).some((element) => {
        if (element.children.length > 0) return false;
        return /^(agotado|sold out)$/i.test((element.textContent || '').trim());
      });

      card.classList.toggle('mbl-phase1-hidden-card', soldOut);
      if (soldOut) card.setAttribute('aria-hidden', 'true');
      else card.removeAttribute('aria-hidden');
    });
  };

  const fixParasitolBuyCta = () => {
    const landing = document.querySelector('[data-parasitol-landing]');
    if (!landing) return;

    const buyLink = landing.querySelector('.mp-navbuy');
    const form = landing.querySelector('.mp-form');
    if (!buyLink || !form) return;

    form.id = 'mp-purchase';
    form.style.scrollMarginTop = '160px';
    buyLink.setAttribute('href', '#mp-purchase');
    buyLink.setAttribute('aria-controls', 'mp-purchase');

    if (buyLink.dataset.mblBuyCtaReady === 'true') return;
    buyLink.dataset.mblBuyCtaReady = 'true';

    buyLink.addEventListener('click', (event) => {
      event.preventDefault();
      const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      form.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  };

  const refresh = () => {
    normalizeSpanishLinks();
    translateReviewCopy();
    removeLegacyProductSections();
    blockForcedUnavailableProduct();
    hideSoldOutCards();
    fixParasitolBuyCta();
  };

  const scheduleRefresh = () => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 80);
  };

  document.addEventListener('DOMContentLoaded', () => {
    scheduleRefresh();

    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes.length > 0)) scheduleRefresh();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener('shopify:section:load', scheduleRefresh);
  document.addEventListener('shopify:cart:view', scheduleRefresh);
  window.addEventListener('pageshow', scheduleRefresh);
})();
